/* VINOD mobile UI behaviour — drawer open/close that cannot be defeated by ancestor
   stacking or stylesheet order.

   Why this exists: the drawer markup lives inside the sticky <header>. A fixed overlay
   nested in a sticky/transformed ancestor can end up clipped or behind the page, and the
   header's own CSS toggled display:none/flex (not animatable). On init the drawer is
   re-parented to <body> and every open/close state is written as INLINE style, so it no
   longer depends on which stylesheet wins. Loaded by sections/vinod-footer.liquid.

   The ACCORDION is deliberately NOT bound here — vinod-header.js already owns it. Two
   handlers on the same head both toggled .is-open, so every tap opened and immediately
   closed the sub-menu and no collection list would expand. Chevron rotation is CSS. */
(function () {
  'use strict';

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  function init() {
    var drawer = document.querySelector('[data-vd-drawer]');
    if (!drawer || drawer.getAttribute('data-vd-mui')) return;
    drawer.setAttribute('data-vd-mui', '1');

    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);

    var panel = drawer.querySelector('.vd-hdr__panel');
    var scrim = drawer.querySelector('.vd-hdr__scrim');

    function paint(on) {
      drawer.classList.toggle('is-open', on);
      drawer.style.display = 'flex';
      drawer.style.position = 'fixed';
      drawer.style.inset = '0';
      drawer.style.zIndex = '9999';
      drawer.style.visibility = on ? 'visible' : 'hidden';
      drawer.style.pointerEvents = on ? 'auto' : 'none';
      if (scrim) {
        scrim.style.transition = 'opacity 0.26s ease';
        scrim.style.opacity = on ? '1' : '0';
      }
      if (panel) {
        panel.style.transition = 'transform 0.32s cubic-bezier(0.32, 0.72, 0, 1)';
        panel.style.transform = on ? 'translateX(0)' : 'translateX(-102%)';
      }
      document.documentElement.style.overflow = on ? 'hidden' : '';
      document.body.style.overflow = on ? 'hidden' : '';
      each(document.querySelectorAll('[data-vd-drawer-open]'), function (o) {
        o.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    paint(false);

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-vd-drawer-open]')) { e.preventDefault(); paint(true); return; }
      if (t.closest('[data-vd-drawer-close]')) { paint(false); return; }
      if (scrim && (t === scrim || t.closest('.vd-hdr__scrim'))) { paint(false); }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) paint(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
